export const ACCESS_GROUPS = [
  {
    key: "email",
    label: "Email",
    components: [
      {
        key: "outlook",
        label: "Outlook",
        description: "Outlook email and calendar access",
      },
    ],
  },
  {
    key: "bre",
    label: "BR&E",
    components: [
      {
        key: "companies",
        label: "Companies",
        description: "BR&E company records and pipeline",
      },
      {
        key: "membership",
        label: "Membership",
        description: "Chamber of commerce member company records and pipeline",
      },
      {
        key: "contacts",
        label: "Contacts",
        description: "BR&E contact records",
      },
      {
        key: "incubators",
        label: "Incubators",
        description: "Incubator company records",
      },
      {
        key: "surveys",
        label: "Surveys",
        description: "Survey templates, responses, and stats",
      },
    ],
  },
  {
    key: "prospecting",
    label: "Prospecting",
    components: [
      {
        key: "companies",
        label: "Companies",
        description: "Prospect company records and pipeline",
      },
      {
        key: "contacts",
        label: "Contacts",
        description: "Prospect contact records",
      },
      {
        key: "inquiries",
        label: "Inquiries",
        description: "Prospect inquiries and conversion",
      },
      {
        key: "trade_shows",
        label: "Trade Shows",
        description: "Trade show search and saved shows",
      },
      {
        key: "trade_show_agent",
        label: "Trade Show Agent",
        description: "Agentic trade show workspaces and exhibitor outreach",
        defaultEnabled: false,
      },
      {
        key: "website_visits",
        label: "Website Visits",
        description: "Website visits, traffic metrics, and visitor tags",
      },
      {
        key: "site_consultants",
        label: "Site Consultants",
        description: "Site consultant search and saved consultants",
      },
      {
        key: "weekly_prospects",
        label: "Weekly Prospects",
        description: "Weekly prospect notifications and add-to-prospecting",
      },
    ],
  },
  {
    key: "other",
    label: "Other",
    components: [
      {
        key: "fiscal_impact",
        label: "Economic Impact",
        description: "Economic impact analysis workspace and RIMS-based modeling",
      },
      {
        key: "retail",
        label: "Retail",
        description: "Retail concepts and retail trend analysis",
      },
      {
        key: "geographic-targeting",
        label: "Geographic Targeting",
        description: "Interactive industry and geography targeting map",
      },
      {
        key: "property_management",
        label: "Property Management",
        description: "Property management workspace and property records",
        defaultEnabled: false,
      },
    ],
  },
];

export const DEFAULT_COMPONENT_CONFIG = ACCESS_GROUPS.reduce((acc, group) => {
  acc[group.key] = group.components
    .filter((component) => component.defaultEnabled !== false)
    .map((component) => component.key);
  return acc;
}, {});

function splitComponentKey(componentKey) {
  const value = String(componentKey || "").trim().toLowerCase();
  const [group, component] = value.split(".");
  return { group, component };
}

export function normalizeComponentConfig(value) {
  const next = {};

  if (Array.isArray(value)) {
    value.forEach((componentKey) => {
      const { group, component } = splitComponentKey(componentKey);
      if (!group || !component) return;
      next[group] = next[group] || [];
      if (!next[group].includes(component)) next[group].push(component);
    });
  } else if (value && typeof value === "object") {
    Object.entries(value).forEach(([group, components]) => {
      if (!Array.isArray(components)) return;
      next[group] = next[group] || [];
      components.forEach((component) => {
        const clean = String(component || "").trim().toLowerCase();
        if (!clean) return;
        if (!next[group].includes(clean)) next[group].push(clean);
      });
    });
  }

  return next;
}

export function flattenComponentConfig(value) {
  const config = normalizeComponentConfig(value);
  return Object.entries(config).flatMap(([group, components]) =>
    components.map((component) => `${group}.${component}`),
  );
}
